<!--  -->
<template>
    <div class="messageIssue padding-20 bgc box-shadow">
        <p class="warning"><i class="el-icon-warning"></i>请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。</p>
        <el-form ref="form" :model="item" :rules="rules" label-width="76px">
            <el-form-item label="标题" prop="subject">
                <el-input :disabled="disabled" class="el_input" maxlength="90" show-word-limit placeholder="请输入标题" v-model="item.subject"></el-input>
            </el-form-item>
            <el-form-item label="导读">
                <el-input :disabled="disabled" class="el_input_textarea" type="textarea" maxlength="100" show-word-limit placeholder="请输入导读" v-model="item.guidance"></el-input>
            </el-form-item>
            <el-form-item label="资讯类型">
                <el-select :disabled="disabled" v-model="item.typecode" placeholder="请选择">
                    <el-option v-for="(item, index) in typecodeArr" :key="index" :label="item.typename" :value="item.typecode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="专题分类">
                <el-select :disabled="disabled" v-model="item.topiccolumncode" placeholder="请选择">
                    <el-option v-for="(item, index) in topiccolumncodeArr" :key="index" :label="item.name" :value="item.innerid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封面图" class="cover_img_box">
                <div class="cover_img">
                    <i class="el-icon-picture" v-if="!item.logourl"></i>
                    <img class="img" :src="item.logourl + '?' + time" v-if="item.logourl" alt="">
                    <!-- <img :src="require('@/common/images/cms/close.png')" @click="deleteMiddleadurl" v-if="item.middleadurl" class="close" alt=""> -->
                </div>
                <div class="btn_tips">
                    <div class="btn">
                        <UploadFile :fileRule="fileRule" :uploadType="uploadType" @setFile="getLogourl" />
                        <el-button :disabled="disabled" type="warning" @click="showScrollBox">素材库</el-button>
                    </div>
                    <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                </div>
            </el-form-item>
            <el-form-item label="正文" prop="content">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
            </el-form-item>
            <el-form-item>
                <div class="original_box">
                    <el-checkbox :disabled="disabled" v-model="checked">声明原创</el-checkbox>
                    <p class="tips">声明原创要求：正文字数>300，且原创内容多于引用内容。 抄袭 、洗稿等滥用原创行为将有处罚，详见<span>《声明原创须知》</span></p>
                </div>
            </el-form-item>
            <el-form-item prop="sourceurl" v-if="!checked">
                <div class="sourceurl">
                    <div class="label">转载来源</div>
                    <el-input :disabled="disabled" v-model="item.sourceurl" placeholder="请输入转载来源"></el-input>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit(0)" v-if="!disabled">发布</el-button>
                <el-button type="warning" @click="submit(1)" v-if="!item.innerid || (item.innerid && item.status === '0')">存至草稿</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </el-form-item>
        </el-form>
        <scrollBox ref="scrollBox" :uploadType="uploadType" @saveMaterialFile="getLogourl"></scrollBox>
    </div>
</template>

<script>
import {getSxytopiccolumninfo, uploadSxytopiccontentinfo, getSxytopiccontentinfo} from 'api/imageText'
import {mapActions} from 'vuex'
import ScrollBox from '@/base/scrollBox/scrollBox'
import UploadFile from '@/base/upload/uploadFile2'
import UEditor from 'base/uEditor/uEditor5'
export default {
    data() {
        const checkSourceurl = (rule, value, callback) => {
            if (!this.checked) {
                if (!this.item.sourceurl) {
                    callback(new Error('请输入转载来源'))
                } else {
                    callback()
                }
            } else {
                callback()
                
            }
        }
        const checkContent = (rule, value, callback) => {
            if (this.checked) {
                if (this.item.content.length <= 300) {
                    callback(new Error('原创声明要求正文字数>300'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            item: {
                articletype: 2, // 文章类型 1原创 2转载
                content: '', // 资讯内容
                guidance: '', // 资讯导读
                innerid: '', // 资讯ID
                isdraft: '', // 状态 0否 1是
                logoattid: '', // 封面id
                logourl: '', // 封面url
                sourceurl: '', // 转载时使用 文章链接
                subject: '', // 资讯标题
                topiccolumncode: '', // 专题分类code
                topiccolumnname: '', // 专题分类名称
                typecode: '', // 资讯类型
                typename: '', // 资讯类型名称
                topiccode: this.$route.query.topiccode ? this.$route.query.topiccode : '',
                topicname: this.$route.query.topicname ? this.$route.query.topicname : ''
            },
            checked: false,
            rules: {
                subject: [
                    {required: true, message: '请输入标题', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '请输入正文', trigger: 'blur'},
                    {validator: checkContent, trigger: 'blur'}
                ],
                sourceurl: [
                    {validator: checkSourceurl, trigger: 'blur'}
                ]
            },
            topiccolumncodeArr: [],
            typecodeArr: [
                {typecode: 'cycx', typename: '产业'},
                {typecode: 'sygl', typename: '智库'},
                {typecode: 'pevc', typename: 'PE/VC'},
                {typecode: 'ss', typename: '解码IPO'},
                {typecode: 'bgcz', typename: '投融资'},
                {typecode: 'gdxw', typename: '滚动新闻'},
                {typecode: 'hyqs', typename: '行业趋势'},
                {typecode: 'rwdh', typename: '人物对话'},
                {typecode: 'hdbd', typename: '活动报道'},
                {typecode: 'sssj', typename: '上市事件'},
                {typecode: 'rzsj', typename: '融资事件'},
                {typecode: 'bgsj', typename: '并购事件'},
                {typecode: 'mzsj', typename: '募资事件'}
            ],
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 750,
                height: 420,
                nottype: true
            },
            disabled: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getSxytopiccolumninfo()
        if (this.$route.query.innerid) {
            this.getSxytopiccontentinfo()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        getSxytopiccontentinfo() {
            this.setLoading(true)
            getSxytopiccontentinfo({
                data: {innerid: this.$route.query.innerid},
                success: res => {
                    this.setLoading(false)
                    res.data.topiccode = this.$route.query.topiccode ? this.$route.query.topiccode : ''
                    res.data.topicname = this.$route.query.topicname ? this.$route.query.topicname : ''
                    this.item = res.data
                    this.$refs.uEditor.init(this.item.content)
                    if (this.item.status === '100') {
                        this.disabled = true
                    }
                    if (this.item.articletype === '1') {
                        this.checked = true
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getSxytopiccolumninfo() {
            this.setLoading(true)
            getSxytopiccolumninfo({
                data: {topiccode: this.item.topiccode},
                success: res => {
                    this.setLoading(false)
                    this.topiccolumncodeArr = res.data.content
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        showScrollBox() {
            this.$refs.scrollBox.openDialog()
        },
        getLogourl(file) {
            if (!this.disabled) {
                this.item.logourl = file.furl
                this.item.logoattid = file.key
            }
        },
        getUEditorContent(content) {
            if (!this.disabled) {
                this.item.content = content
            }
        },
        submit(isdraft) {
            this.item.isdraft = isdraft
            if (this.item.topiccolumncode) {
                this.topiccolumncodeArr.some((item) => {
                    if (item.innerid === this.item.topiccolumncode) {
                        this.item.topiccolumnname = item.name
                        return true
                    }
                })
            }
            if (this.item.typecode) {
                this.typecodeArr.some((item) => {
                    if (item.typecode === this.item.typecode) {
                        this.item.typename = item.typename
                        return true
                    }
                })
            }
            if (this.checked) {
                this.item.articletype = 1
            } else {
                this.item.articletype = 2
            }
            this.$refs.form.validate((valid, errlist) => {
                if (valid) {
                    this.setLoading(true)
                    uploadSxytopiccontentinfo({
                        data: this.item,
                        success: res => {
                            this.setLoading(false)
                            this.$router.push({
                                name: 'SpecialConfig',
                                query: {
                                    topiccode: this.item.topiccode,
                                    topicname: this.item.topicname,
                                    activeName: 'third'
                                }
                            })
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.$message.error('请完善您的数据！')
                }
            })
        },
        handleCancel() {
            this.$router.back(1)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ScrollBox,
        UploadFile,
        UEditor
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .messageIssue {
        .warning {
            height: 44px;
            line-height: 44px;
            background: #FDF6EC;
            color: #E6A23C;
            padding-left: 10px;
            border-radius: 4px;
            font-size: 13px;
            margin-bottom: 26px;
            .el-icon-warning {
                margin-right: 10px;
            }
        }
        .el-form {
            .el-form-item__label {
                text-align: left;
            }
            .el_input {
                width: 810px;
            }
            .el_input_textarea {
                width: 810px;
                height: 85px;
                .el-textarea__inner {
                    resize: none;
                    height: 85px;
                }
            }
            .el-select {
                width: 440px;
                .el-input__icon {
                    line-height: 32px;
                }
            }
            .cover_img_box {
                .el-form-item__label {
                    line-height: 20px;
                }
                .el-form-item__content {
                    display: flex;
                    align-items: center;
                    .cover_img {
                        width: 280px;
                        height: 158px;
                        background: #F5F7FA;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 4px;
                        margin-right: 50px;
                        position: relative;
                        .img {
                            width: 280px;
                            height: 158px;
                            border-radius: 4px;
                        }
                        .el-icon-picture {
                            font-size: 44px;
                            color: #DCDFE6;
                        }
                        .close {
                            position: absolute;
                            width: 20px;
                            height: 20px;
                            right: -10px;
                            top: -10px;
                            cursor: pointer;
                        }
                    }
                    .btn_tips {
                        .btn {
                            display: flex;
                            align-items: center;
                            margin-bottom: 12px;
                            .el-button--warning {
                                margin-left: 20px;
                            }
                        }
                        .tips {
                            font-size: 14px;
                            color: #C0C4CC;
                            line-height: 20px;
                        }
                    }
                }
            }
            .edui-editor, .edui-editor-iframeholder {
                width: 816px !important;
            }
            .original_box {
                display: flex;
                line-height: 18px;
                // margin-bottom: 20px;
                .el-checkbox__label {
                    color: #303133;
                }
                .tips {
                    margin-left: 34px;
                    color: #909399;
                    font-size: 14px;
                    width: 382px;
                    line-height: 18px;
                    span {
                        color: #409EFF;
                    }
                }
            }
            .sourceurl {
                display: flex;
                line-height: 18px;
                align-items: center;
                .label {
                    margin-right: 20px;
                    color: #303133;
                    font-size: 14px;
                    &::after {
                        content: '*';
                        color: #F56C6C;
                        margin-left: 4px;
                    }
                }
                .el-input {
                    width: 740px;
                }
            }
            .el-button--warning {
                margin: 0 22px 0 32px;
            }
            .is-required {
                .el-form-item__label::before {
                    content: '';
                }
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    margin-right: 4px;
                }
            }
        }
    }
</style>